<script setup lang="ts">
import {
  PhxsgSlide as PhxsgCoreSlide,
  type PhxsgSlideProps as PhxsgCoreSlideProps,
} from '@sg-core/src/View/Components/Organisms/Slider';

defineProps<PhxsgCoreSlideProps>();

/**
 * Define the component name to be 'SwiperSlide' so that
 * swiper detects the direct children as slides.
 */
defineOptions({
  name: 'SwiperSlide',
});
</script>

<template>
  <PhxsgCoreSlide v-bind="$props">
    <slot />
  </PhxsgCoreSlide>
</template>
